exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._15a5v4fyTT4J7u{font-weight:400;box-shadow:none;margin:0;padding:0}._15a5v4fyTT4J7u,._15a5v4fyTT4J7u:active,._15a5v4fyTT4J7u:focus,._15a5v4fyTT4J7u:hover{background:none}.sLa3Mli4qACAme{padding-bottom:20px}._1yPmiQ_g38_F0e{display:flex;flex-direction:column;will-change:max-height}._1yPmiQ_g38_F0e:not(:empty)+._1yPmiQ_g38_F0e{padding-top:16px}._1yPmiQ_g38_F0e:last-child{padding-bottom:0}._3Z9M4pQsnhV7Kv{font-weight:400;box-shadow:none;margin:0;padding:0;width:100%;text-decoration:underline}._3Z9M4pQsnhV7Kv,._3Z9M4pQsnhV7Kv:active,._3Z9M4pQsnhV7Kv:focus,._3Z9M4pQsnhV7Kv:hover{background:none}._3Z9M4pQsnhV7Kv:hover{color:#111}._1B-j2mwkaHHJXT{padding:19px 0}", ""]);

// exports
exports.locals = {
	"m-button-no-style": "_15a5v4fyTT4J7u",
	"highlightSection": "sLa3Mli4qACAme",
	"highlight": "_1yPmiQ_g38_F0e",
	"showMoreButton": "_3Z9M4pQsnhV7Kv",
	"spinnerWrapper": "_1B-j2mwkaHHJXT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2772/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/highlight-section.less
// module id = uaLM
// module chunks = 13